import { countriesApi } from './countriesApi'
import { CountryDTO } from './countriesTypes'

async function getCountries(): Promise<{ countries: CountryDTO[] }> {
  return countriesApi.fetchCountries()
}

export const countriesServices = {
  getCountries,
}
